import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * 家族連絡サービスプラン API 操作クラス
 */
export default class Plans {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET Plans
   */
  public async gets(userStore: LoginUser): Promise<Array<PlansGetModel>> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.Plans, formatParams);
    const response = await this.commonService.executeGet<Array<PlansGetModel>>(userStore, requestUrl, this.constructor.name, {}, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

/**
 * ### プラン
 */
export interface PlansGetModel {
  /** プラン種別 */
  type: PlanType;
  /** プラン */
  plan: Plan;
  /** プラン名 */
  name: string;
  /** 料金 */
  price: number;
  /** 利用者人数上限 (無制限は-1) */
  residentLimit: number;
  /** 家族人数上限 (無制限は-1) */
  familyLimit: number;
  /** 課金種別 */
  billingType: BillingType;
}

export interface PlanDetail {
  /** 料金 */
  price: number;
  /** 利用者人数上限 (無制限は-1) */
  residentLimit: number;
  /** 家族人数上限 (無制限は-1) */
  familyLimit: number;
}

/**
 * ### プラン種別
 */
export enum PlanType {
  UNKNOWN = -1,
  FREE = 0,
  LIGHT = 1,
  BASIC = 2,
  ENTRY = 90
}

/**
 * ### プラン
 */
export enum Plan {
  UNKNOWN = -1,
  PLAN_PLUS = 0,
  PLAN_20 = 20,
  PLAN_50 = 50,
  PLAN_100 = 100
}

export enum BillingType {
  FLAT_RATE = 0,
  PAY_PER_USE = 1
}
